module.exports = __webpack_public_path__ + "img/04-4.de920939.png";